import React from 'react';
import { HiOutlineShieldCheck, HiOutlineClock, HiOutlineLockClosed } from 'react-icons/hi2';

const TRUST_ITEMS = [
  { icon: HiOutlineShieldCheck, text: 'Cancel anytime' },
  { icon: HiOutlineLockClosed, text: 'Secured by Stripe' },
];

const TrustBar = () => (
  <div className="py-5">
    <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 px-6 py-3.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/30 border border-gray-100 dark:border-gray-800/40">
      {TRUST_ITEMS.map(({ icon: Icon, text }) => (
        <div key={text} className="flex items-center gap-2">
          <Icon className="w-4 h-4 text-emerald-500 dark:text-emerald-400" />
          <span className="text-sm text-gray-600 dark:text-gray-400 font-medium">{text}</span>
        </div>
      ))}
    </div>
  </div>
);

export default TrustBar;
